export default class CartService {
    static cartItemsIds = [];
    static inited = false;
    static cartTag = 'cart_items_list';

    static initCart(){
        let arr = localStorage.getItem(this.cartTag)
        if(arr){
            try{
                this.cartItemsIds = JSON.parse(arr);
                this.inited = true;
            }catch (e){
                this.cartItemsIds = [];
                this.inited = false;
            }
        }else{
            this.inited = true;
            this.saveLocalStorage();
        }
    }

    static saveLocalStorage(){
        if(this.inited){
            try {
                localStorage.setItem(this.cartTag, JSON.stringify(this.cartItemsIds));
            }catch (e){
                this.inited = false
                console.log(e)
            }
        }else{
            console.log('Cart save error')
        }
    }

    static clearCart(){
        this.cartItemsIds = [];
        this.saveLocalStorage();
    }

    static countCartItems(){
        return this.cartItemsIds.length;
    }

    static countCartItemsById(id){
        let itemFind = this.cartItemsIds.find(item => item.id === id)
        if(itemFind){
            return itemFind.count
        }else{
            return 0;
        }
    }

    static addCartItem(id, count){
        this.cartItemsIds.push({
            id: id,
            count: count
        })
        this.saveLocalStorage();
    }
    static increaseCartItem(id, count){
        if(this.cartItemsIds.find(item => item.id === id)){
            this.cartItemsIds = this.cartItemsIds.map(item => {
                if (item.id === id) {
                    return {
                        id: id,
                        count: item.count + count
                    }
                } else {
                    return item
                }
            });

            this.saveLocalStorage();
        }
    }
    static decreaseCartItem(id, count){
        this.cartItemsIds = this.cartItemsIds.map(item => {
            if (item.id === id) {
                if (item.count <= count) {
                    return {
                        id: id,
                        count: 0
                    }
                } else {
                    return {
                        id: id,
                        count: item.count - count
                    }
                }
            } else {
                return item
            }
        });

        this.cartItemsIds = this.cartItemsIds.filter(item => item.count > 0);

        this.saveLocalStorage();
    }

    static removeCartItems(id){
        this.cartItemsIds = this.cartItemsIds.filter(item => item.id !== id);
        this.saveLocalStorage();
    }
}